import { atom } from 'recoil'
import { IOrganization } from '@/pages/Organizations/organizations.types.ts'

export interface IOrganizationsState {
  items: IOrganization[]
}

const organizationsAtom = atom<IOrganizationsState>({ key: 'organizations', default: { items: [] } })
export default organizationsAtom
